import { useEffect, useRef, useState } from "react";

const DEFAULT_ROOT_MARGIN = "320px 0px";

/**
 * Mount heavy children only while the section is near the viewport.
 * Keeps the section shell in the DOM for scroll layout.
 */
export function useSectionInView({ rootMargin = DEFAULT_ROOT_MARGIN, threshold = 0 } = {}) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { rootMargin, threshold },
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [rootMargin, threshold]);

  return { ref, inView };
}
